<template>
  <div class="col-12 p-0">
    <div class="row m-0">
      <div class="col-12">
        <h5>{{ title }}</h5>
      </div>
      <div class="col-12 mb-3 cardbg p-3">
        <slot></slot>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Card',
  props: ['title']
}
</script>
